function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h2',[_vm._v("Find us on the Internet")]),_vm._v(" "),_c('p',[_vm._v("Since you are on this page, you’ve already finished your first interaction - expressing interest in WhiteBox. Now you could just directly click on "),_c('a',{attrs:{"href":"http://www.google.com/search?q=whitebox+digital+marketing+intelligence","title":"WhiteBox Demo Search in Google"}},[_vm._v("this link, to search for WhiteBox in Google")]),_vm._v(". You may notice WhiteBox ads on Facebook too. You can simulate traffic from differet sources by clicking to one of the following links:")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/interactions/ads/details","sources":[{"traffic":"Search traffic","source":"search"},{"traffic":"Social media traffic","source":"social"},{"traffic":"Referral traffic","source":"referral"},{"traffic":"Display ads traffic","source":"display"},{"traffic":"Message traffic","source":"message"}]},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }